import {Component, EventEmitter, inject, OnInit, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from "@wms/components";
import {PageTemplateComponent} from "@wms/app/components/page-template/page-template.component";
import {PageLayoutsService} from "@wms/page-workspace";
import {PageWsService} from "@wms/workspace";
import {DialogService} from "@wms/services";
import {MarkupManagerService} from "@wms/core";
import {EventManager} from "@angular/platform-browser";
import {EventManagerService} from "@wms/app";

@Component({
  selector: 'wms-change-layout',
  standalone: true,
  imports: [CommonModule, WmsDialogHeaderComponent, WmsDialogBodyComponent, PageTemplateComponent, WmsDialogFooterComponent],
  templateUrl: './wms-change-layout.component.html',
  styleUrls: ['./wms-change-layout.component.less']
})
export class WmsChangeLayoutComponent extends  BaseComponent implements OnInit {

  baseScreen: string;
  layouts: any;
  activeLayout: any;

  pageLayoutsService:PageLayoutsService;
  pageWsService: PageWsService;
  markupManagerService: MarkupManagerService;
  eventManagerService: EventManagerService;

  constructor(private dialogService: DialogService) {
    super();
    this.dialogService = inject(DialogService);
    this.pageLayoutsService = inject(PageLayoutsService);
    this.pageWsService = inject(PageWsService)
    this.markupManagerService = inject(MarkupManagerService);
    this.eventManagerService = inject(EventManagerService);
  }

  ngOnInit(): void {
    this.baseScreen = 'layoutOptions';
    this.layouts = this.pageLayoutsService.getPageLayouts();
    this.activeLayout = this.pageWsService.layout;
  }
  close(): void {
    this.dialogService.close('layoutOptions');
  }
  switchLayout() {
    this.eventManagerService.emitSwitchPageLayout(this.activeLayout);
    this.pageWsService.layout = this.activeLayout;
    this.dialogService.close('layoutOptions');
  }
  layoutSelected = (layout: any) => {
    this.activeLayout = layout;
  }
  }
